import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const WorkspaceSettingsOrganizationUpdateDomainDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"WorkspaceSettingsOrganizationUpdateDomain"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"domain"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"traceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}},{"kind":"Argument","name":{"kind":"Name","value":"domain"},"value":{"kind":"Variable","name":{"kind":"Name","value":"domain"}}},{"kind":"Argument","name":{"kind":"Name","value":"traceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"traceId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"domainName"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"WorkspaceSettingsOrganizationUpdateDomain","document":WorkspaceSettingsOrganizationUpdateDomainDocument}} as const;
export type WorkspaceSettingsOrganizationUpdateDomainMutationVariables = Types.Exact<{
  orgId: Types.Scalars['ID'];
  domain: Types.Scalars['String'];
  traceId: Types.Scalars['String'];
}>;


export type WorkspaceSettingsOrganizationUpdateDomainMutation = (
  { __typename: 'Mutation' }
  & { updateOrganization?: Types.Maybe<(
    { __typename: 'Organization' }
    & Pick<Types.Organization, 'id' | 'domainName'>
  )> }
);

export type WorkspaceSettingsOrganizationUpdateDomainMutationFn = Apollo.MutationFunction<
  WorkspaceSettingsOrganizationUpdateDomainMutation,
  WorkspaceSettingsOrganizationUpdateDomainMutationVariables
>;

/**
 * __useWorkspaceSettingsOrganizationUpdateDomainMutation__
 *
 * To run a mutation, you first call `useWorkspaceSettingsOrganizationUpdateDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceSettingsOrganizationUpdateDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [workspaceSettingsOrganizationUpdateDomainMutation, { data, loading, error }] = useWorkspaceSettingsOrganizationUpdateDomainMutation({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      domain: // value for 'domain'
 *      traceId: // value for 'traceId'
 *   },
 * });
 */
export function useWorkspaceSettingsOrganizationUpdateDomainMutation(
  baseOptions?: Apollo.MutationHookOptions<
    WorkspaceSettingsOrganizationUpdateDomainMutation,
    WorkspaceSettingsOrganizationUpdateDomainMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    WorkspaceSettingsOrganizationUpdateDomainMutation,
    WorkspaceSettingsOrganizationUpdateDomainMutationVariables
  >(WorkspaceSettingsOrganizationUpdateDomainDocument, options);
}
export type WorkspaceSettingsOrganizationUpdateDomainMutationHookResult = ReturnType<
  typeof useWorkspaceSettingsOrganizationUpdateDomainMutation
>;
export type WorkspaceSettingsOrganizationUpdateDomainMutationResult = Apollo.MutationResult<WorkspaceSettingsOrganizationUpdateDomainMutation>;
export type WorkspaceSettingsOrganizationUpdateDomainMutationOptions = Apollo.BaseMutationOptions<
  WorkspaceSettingsOrganizationUpdateDomainMutation,
  WorkspaceSettingsOrganizationUpdateDomainMutationVariables
>;
